import { GenericStatus } from "./props";
import { faCheckCircle, faXmarkCircle, faClock } from "@fortawesome/pro-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

const VesselCrewStatus: GenericStatus[] = [
    {key: "active", text: "Active", tagVariant: 'active'},
    {key: "deactive", text: "Deactive", tagVariant: 'error'}
]

export default VesselCrewStatus;